module.exports = __webpack_public_path__ + "static/img/058_TO8_1607.e431ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/058_TO8_1607.jpg
// module id = 6bq8
// module chunks = 0